import { TextField as BaseTextField, createStyles, makeStyles } from '@material-ui/core';
import { TextFieldProps as BaseTextFieldProps } from '@material-ui/core/TextField/TextField';
import clsx from 'clsx';
import React from 'react';
import { Controller } from "react-hook-form";
import InputMask from 'react-input-mask';

export type TextFieldProps = BaseTextFieldProps & {
    name: string;
    mask?: string;
    control: any;
    disable?: boolean;
    rules?: any;
};

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            margin: '10px',
        },
    })
);
const TextField: React.FC<TextFieldProps> = ({
    name,
    helperText,
    defaultValue,
    InputLabelProps,
    mask,
    autoFocus,
    type,
    control,
    onChange,
    disable,
    onBlur,
    inputProps,
    rules,
    ...restProps
}) => {


    const classes = useStyles();

    return (
        <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
            mask ?
             <InputMask 
                mask={mask} 
                onChange={e => {
                    if (onChange){
                        onChange(e)
                    };
                    
                    field.onChange(e);
                }}
                value={field.value}
                onBlur={onBlur}>
             {() => (
                <BaseTextField
                    {...restProps}
                    type={type}
                    value={field.value}
                    error={!!error}
                    helperText={error ? error.message : null}
                    className={clsx(classes.root)}
                    defaultValue={defaultValue}
                    autoFocus={autoFocus}
                    InputLabelProps={{
                        ...InputLabelProps,
                        shrink: true
                    }}
                />)
            }
            </InputMask>
            :
                <BaseTextField
                {...restProps}
                disabled={disable}
                type={type}
                value={field.value}
                onChange={e => {
                    if (onChange){
                        onChange(e)
                    };
                    
                    field.onChange(e);
                }}
                error={!!error}
                helperText={error ? error.message : null}
                className={clsx(classes.root)}
                defaultValue={defaultValue}
                inputProps ={ { ...inputProps } }
                InputLabelProps={{
                    ...InputLabelProps,
                    shrink: true
                }}
            />
            )}
        />
    );
};

export default React.memo(TextField);